import { cn } from "@newxsystems/shared";
import type { IAbyssRichTextProps } from "./AbyssRichText.props";

export const AbyssRichText = ({ className, content }: IAbyssRichTextProps) => (
  <div
    className={cn(
      "font-abyss-body text-base leading-[1.6] text-pretty text-foreground md:text-lg [&_a]:text-primary [&_a]:underline [&_a]:underline-offset-4 [&_blockquote]:border-l [&_blockquote]:border-iron [&_blockquote]:pl-6 [&_blockquote]:text-fog [&_h2]:font-abyss-display [&_h2]:text-3xl [&_h2]:font-medium [&_h2]:leading-tight [&_h3]:font-abyss-display [&_h3]:text-2xl [&_h3]:font-medium [&_h3]:leading-tight [&_li]:my-2 [&_ol]:list-decimal [&_ol]:pl-6 [&_p+p]:mt-5 [&_strong]:font-semibold [&_ul]:list-disc [&_ul]:pl-6",
      className,
    )}
    dangerouslySetInnerHTML={{ __html: content }}
  />
);

AbyssRichText.displayName = "Content::AbyssRichText";
